<template>
  <div class="metrics" style="margin-top: 2%;">
    <el-row justify="center" type="flex">
      <el-col  :span="20" >
        <el-table v-loading="pieLoading"
          :data="tableDataPage.filter(data => !search || data.instance.toLowerCase().includes(search.toLowerCase()))">
          <el-table-column prop="instance" label="Instance Name" align="left"></el-table-column>
          <el-table-column prop="status" label="Status" align="left"></el-table-column>
          <el-table-column prop="pvCount" label="PV Count" align="left"></el-table-column>
          <el-table-column prop="connectedPVCount" label="Connected"  align="left"></el-table-column>
          <el-table-column prop="MGMT_uptime" label="Mgmt Uptime"  align="left"></el-table-column>
          <el-table-column label="Operate" align="center">
            <template slot="header" slot-scope="scope">
              <el-input  v-model="search" size="large" placeholder="keyword search"/>
            </template>
            <template slot-scope="scope">
              <el-button  title="Detail" type="primary" icon="el-icon-view" circle  @click="handleDetail(scope.$index,scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination 
          background
          layout="total,prev,pager,next"
          :total="gridData.length"
          :page-count="Math.ceil(gridData.length/pageSize)"
          :current-page.sync="currentPage"
          @current-change ="currentPageChange"
          :page-size = "pageSize">
        </el-pagination>
      </el-col>
    </el-row>
    <appliancesDetail v-if="isLookDetail" 
    @close = "close" 
    :detailInfo="detailInfo"
    ></appliancesDetail>
  </div>
</template>

<script>
import appliancesDetail from  './appliancesDetail'
    export default {
      name: "metrics",
      components:{appliancesDetail},
      data(){
          return {
            iconLoading:true,
            disabled:false,
            pieLoading:false,

            pageNumber:0,
            pageSize:8,
            currentPage:1,

            gridData: [],
            isLookDetail:false,
            queryFrom:{
              keywords:''
            },
            detailInfo:{},
            search:'',
            tableDataPage:[]
          }
      },
      mounted(){
          this.query();
      },
      methods:{
        query:function () {
          this.$axios({ 
              method:'get',
                url:'/hdars/hdars/mgmt/getInstanceMetrics'
              }).then((response) => {
            this.gridData = response.data;
            this.tableDataPage = this.gridData.slice((this.currentPage-1)*this.pageSize,this.currentPage*this.pageSize);
          })
        },
        handleDetail(index,row){
          this.detailInfo = row;
          this.isLookDetail = true;
        },
        currentPageChange:function(val){
          this.currentPage = val;
        },
        resetForm(formName) {
          this.$refs[formName].resetFields();
        },
        searchForm(formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              alert('search!');
            } else {
              console.log('error search!!');
              return false;
            }
          });
        },
        close:function(){
          this.isLookDetail = false;
        }
      }
    }

</script>

<style>
  .metrics .el-form-item__label{width:110px;}
  .metrics .el-form-item__content{margin-left:110px}
  .metrics .queryFromClass .el-form-item{display: inline-block;}
  .metrics .el-select{width:100%;}
</style>



// WEBPACK FOOTER //
// src/page/activePublic/Metrics/appliances.vue